import { render, staticRenderFns } from "./MasterAssignedGroupClassList.vue?vue&type=template&id=2a8a5223"
import script from "./MasterAssignedGroupClassList.vue?vue&type=script&lang=js"
export * from "./MasterAssignedGroupClassList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports